"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditLogEntrySchema = exports.AuditEmailType = exports.AuditEmailTypeEnum = exports.AuditStatus = exports.AuditObjectType = exports.AuditEventType = exports.AuditStatusEnum = exports.AuditObjectTypeEnum = exports.AuditEventTypeEnum = void 0;
const zod_1 = require("zod");
// Enums
exports.AuditEventTypeEnum = zod_1.z.enum([
    'LOGIN',
    'LOGIN_FAILED',
    'PASSWORD_RESET',
    'TOKEN_REFRESH',
    'WEBHOOK_RECEIVED',
    'WEBHOOK_PROCESSED',
    'WEBHOOK_FAILED',
    'DISCLOSURE_CREATED',
    'DISCLOSURE_UPDATED',
    'DISCLOSURE_STAGE_CHANGED',
    'DISCLOSURE_APPROVED',
    'DISCLOSURE_REJECTED',
    'CASE_CREATED',
    'CASE_STATE_CHANGED',
    'FILE_UPLOADED',
    'FILE_DOWNLOADED',
    'FILE_DELETED',
    'CONTRIBUTOR_SIGNOFF',
    'HOD_SIGNOFF',
    'DEAN_SIGNOFF',
    'DRD_SIGNOFF',
    'TTO_DIRECTOR_SIGNOFF',
    'EMAIL_SENT',
    'USER_CREATED',
    'INVITE_CREATED',
    'INVITE_ACCEPTED',
    'INVITE_RESENT',
    'LICENSE_CREATED',
    'LICENSE_UPDATED',
    'LICENSE_FILE_UPLOADED',
    'LICENSEE_CREATED',
    'LICENSEE_UPDATED',
    'PATENT_CREATED',
    'PATENT_UPDATED',
    'CONTACT_CREATED',
    'CONTACT_UPDATED',
    'CONTACT_DELETED',
    'FACULTY_CREATED',
    'FACULTY_UPDATED',
    'FACULTY_DELETED',
    'CASE_ASSESSMENT_FORM_CREATED',
    'CASE_ACTION_COMPLETED',
]);
exports.AuditObjectTypeEnum = zod_1.z.enum([
    'USER',
    'DISCLOSURE',
    'CASE',
    'FILE',
    'WEBHOOK',
    'PATENT',
    'LICENSE',
    'LICENSEE',
    'CONTRIBUTOR',
    'HOD',
    'DEAN',
    'DRD',
    'TTO_DIRECTOR',
    'INVITE',
    'CONTACT',
    'FACULTY',
]);
exports.AuditStatusEnum = zod_1.z.enum([
    'STARTED',
    'SUCCESS',
    'FAILURE',
    'PENDING',
]);
// Usable const values — use these instead of string literals in handlers/services
exports.AuditEventType = exports.AuditEventTypeEnum.enum;
exports.AuditObjectType = exports.AuditObjectTypeEnum.enum;
exports.AuditStatus = exports.AuditStatusEnum.enum;
exports.AuditEmailTypeEnum = zod_1.z.enum([
    'CONTRIBUTOR_APPROVAL_REQUEST',
    'CONTRIBUTOR_APPROVAL_RESEND',
    'HOD_APPROVAL_RESEND',
    'NEW_DISCLOSURE_TO_OFFICER',
    'VALIDATION_ERROR_TO_SUBMITTER',
    'EDIT_RECEIVED_TO_HEAD_OF_TTO',
    'HOD_APPROVAL_REQUEST_BULK',
    'DRD_APPROVAL_REQUEST',
    'TTO_DIRECTOR_APPROVAL_REQUEST',
    'DEAN_APPROVAL_REQUEST_BULK',
    'CONTRIBUTOR_APPROVAL_REQUEST_BULK',
    'EDIT_REQUEST_MULTI_RECIPIENT',
    'EDIT_REQUEST_TO_SUBMITTER',
    'COLLABORATOR_REJECTED_TO_TTO',
    'HOD_REJECTED_TO_TTO',
    'DEAN_REJECTED_TO_TTO',
    'DRD_REJECTED_TO_TTO',
    'TTO_DIRECTOR_REJECTED_TO_TTO',
    'DUE_DILIGENCE_TO_HEAD_OF_TTO',
    'TTO_DIRECTOR_REVIEW_REQUEST',
    'REJECT_CONSENT_TO_TTO_DIRECTOR',
    'ADDITIONAL_INFO_TO_TTO',
    'ADDITIONAL_INFO_TO_SUBMITTER',
    'FORWARD_EDIT_REQUEST',
    'NO_COMMERCIALISATION_DECISION_TO_SUBMITTER',
    'DEAN_APPROVAL_RESEND',
    'DRD_APPROVAL_RESEND',
    'TTO_DIRECTOR_APPROVAL_RESEND',
    'DISCLOSURE_INGEST_ERROR_TO_DEVS',
]);
exports.AuditEmailType = exports.AuditEmailTypeEnum.enum;
// Main AuditLog schema
exports.AuditLogEntrySchema = zod_1.z.object({
    id: zod_1.z.string(), // Mongo ObjectId as string
    eventType: exports.AuditEventTypeEnum,
    actorId: zod_1.z.string().nullish(),
    actorEmail: zod_1.z.string().nullish(),
    actorDisplayName: zod_1.z.string().nullish(),
    serviceName: zod_1.z.string().nullish(),
    ipAddress: zod_1.z.string().nullish(),
    userAgent: zod_1.z.string().nullish(),
    objectType: exports.AuditObjectTypeEnum.nullish(),
    objectId: zod_1.z.string().nullish(),
    reference: zod_1.z.string().nullish(),
    status: exports.AuditStatusEnum,
    message: zod_1.z.string().nullish(),
    payload: zod_1.z.any().optional(),
    payloadTruncated: zod_1.z.boolean().nullish(),
    createdAt: zod_1.z.date(),
});
